module.exports = __webpack_public_path__ + "static/media/unique-desktop.acbf3201.svg";